import { toast } from '@/components/shadcn/ui/use-toast';
import { BusinessCreateType, Business, BusinessUpdateInterface, BusinessTable } from '@/entities/business';
import { BusinessService } from '@/services/BusinessService';
import { useEffect, useState } from 'react';

export function useBusiness(businessId?: number, userId?: number) {
  const [business, setbusiness] = useState<Business>();
  const [business2, setBusiness2] = useState<Business>();
  const [getBusinessId, setGetBusinessId] = useState<number>();
  const [businesCompanySetted, setBusinesCompanySetted] = useState(false);
  const [businessCompany, setBusinessCompany] = useState<BusinessTable[] | []>([]);
  const [businessIdUpdate, setBusinessIdUpdate] = useState(null);

  useEffect(() => {
    const fetchbusinessById = async () => {
      if (!businessId) return;
      const response = await BusinessService.getBusinessById(businessId);
      if (response) {
        setbusiness(response);
        setBusiness2(response);
      }
    };
    fetchBusiness();
    fetchbusinessById();
    // console.log(business);
    // console.log(businessCompany);
  }
    , [businessId, userId]);

  useEffect(() => {
    fetchBusiness();
  }
    , [userId]);

  const fetchBusiness = async () => {
    if (!userId) return;
    const response = await BusinessService.getBusinessByCompanyUser();

    if (response) {
      setBusinessCompany(response);
      setBusinesCompanySetted(!businesCompanySetted);
    }
  };

  const revertAprovedBusiness = async (businessId: number) => {
    const response = await BusinessService.revertAprovedBusiness(businessId);

    if (response) {
      return response;
    }
  };

  const revertCanceledBusiness = async (businessId: number) => {
    const response = await BusinessService.revertCanceledBusiness(businessId);

    if (response) {
      return response;
    }
  };

  const revertDeclineBusiness = async (businessId: number) => {
    const response = await BusinessService.revertDeclineBusiness(businessId);

    if(response) {
      return response;
    }
  }

  const declineBusiness = async (businessId: number, business: BusinessUpdateInterface) => {
    const response = await BusinessService.declineBusiness(Number(businessId), business);

    if(response) {
      return response
    }
  }

  const getAllDeclined = async () => {
    const response = await BusinessService.getAllDecline();

    if(response){
      return response;
    }
  }

  const deleteBusiness = async (id: number) => {
    try {
      const response = await BusinessService.deleteBusiness(id);
      if (response) {
        return response;
      }
    } catch (e) {
      console.error(`Deu ruim, meu chapa ${e}`);
    }
  };

  // create business
  const createBusiness = async (business: BusinessCreateType) => {
    const response = await BusinessService.createBusiness(business);
    if (response) {
      setGetBusinessId(response.id);
      return response;
    }
  };

  const createClientBusiness = async (business: BusinessCreateType) => {
    const response = await BusinessService.createClientBusiness(business);
    if (response) {
      setGetBusinessId(response.id);
      return response;
    }
  };

  const updateBusiness = async (businessId: number, business: BusinessUpdateInterface) => {
    try {
      const result = await BusinessService.updateBusiness(businessId, business);
      return result;
    } catch (e) {
      console.error(`Deu ruim, meu chapa ${e}`);
    }
  };
  const aproveBusiness = async (businessId:number, business: BusinessUpdateInterface) =>{
    try{
      const result = await BusinessService.aproveBusiness(businessId, business);
      return result;
    } catch(e){
      // console.log(e)
    }
  }
  const cancelBusiness = async (businessId:number, business: BusinessUpdateInterface) =>{
    try{
      const result = await BusinessService.cancelBusiness(Number(businessId), business);
      return result;
    } catch(e){
      // console.log(e)
    }
  }
  const getAllCanceled = async () => {
    try{
      const result = await BusinessService.getAllCanceled();
      return result;
    } catch(e){
      // console.log(e)
    }
  }

  const getAllAproved = async () => {
    try{
      const result = await BusinessService.getAllAproved();
      return result;
    } catch(e){
      // console.log(e)
    }
  }

  const getBusinessByDescription = async(description: string) => {
    try {
      const result = await BusinessService.getBusinessByDescription(description);
      return result;
    } catch (e){
      // console.log(`ocorreu um erro`)
    }
  }

  const prepareBusiness = async(businessId: number) => {
    try {
      const result = await BusinessService.prepareBusiness(businessId);
    } catch (e){
      console.log('ocorreu um erro');
    }
}
  return { business, prepareBusiness, declineBusiness, getAllDeclined, revertDeclineBusiness, revertCanceledBusiness, revertAprovedBusiness, getAllAproved, getAllCanceled, aproveBusiness, cancelBusiness, getBusinessByDescription, fetchBusiness, createBusiness,createClientBusiness, deleteBusiness, updateBusiness, businessCompany, business2, getBusinessId };

}
